/**
 * User-facing names for the external data sources.
 *
 * The application ingests from three distinct places, and the dealership has
 * asked that they not be named in the interface. Every visible label goes
 * through this file so the naming is decided in one place rather than in the
 * forty-odd components that display it.
 *
 * The three stay separate because they answer different questions:
 *
 *   listing     — the advertisement itself: specs, description, photos, quality
 *   marketplace — how that advertisement performed: impressions, leads, watchlists
 *   website     — traffic on the dealership's own site
 *
 * Scope: visible text only. Field names in the API payload, CSS class names and
 * the outbound listing links still carry the original naming — anyone reading
 * the network tab or hovering a link can still identify the source. Closing
 * those is a separate, larger change.
 */

const SOURCE_LABELS = {
    // The listing / advertisement
    listing: 'Listing',
    listingLower: 'listing',
    listingDetails: 'Listing Details',
    listingInsights: 'Listing Insights',
    listingCoverageGap: 'Listing Coverage Gap',
    listingsAll: 'All Listings',

    // Marketplace engagement
    marketplace: 'Marketplace',
    marketplaceLower: 'marketplace',

    // The dealership's own website
    website: 'Website',
    websiteLower: 'website',
};

export default SOURCE_LABELS;
